import { memo } from 'react';
import FJTextToImageGenerateNumber from '../view/FJTextToImageGenerateNumber';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJTextToImageGenerateNumberContainer = memo(function FJTextToImageGenerateNumberContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const generateNumber = useSelector(state => state.textToImage.generateNumber);

    const handleChangeGenerateNumber = useCallback(
        value => {
            dispatch(FJActionTextToImage.changeGenerateNumberAction(value));
        },
        [dispatch],
    );

    return <FJTextToImageGenerateNumber generateNumber={generateNumber} onChange={handleChangeGenerateNumber} />;
});

export default FJTextToImageGenerateNumberContainer;
